import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as AriaSwitch } from 'react-aria-components';
import { cn } from '../../utils';
export function Switch({ value, onChange, id, disabled }) {
    return (_jsx(AriaSwitch, { id: id, isSelected: value, onChange: onChange, isDisabled: disabled, className: cn('group inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full p-0.5 transition-colors duration-200', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-400 focus-visible:outline-offset-2', 'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50', {
            'bg-indigo-600': value,
            'bg-gray-200': !value,
        }), children: _jsx("span", { className: cn('pointer-events-none block size-5 shrink-0 rounded-full bg-white shadow transition-all duration-200 ease-out', 'group-data-[disabled]:opacity-50', {
                'translate-x-5': value,
                'translate-x-0': !value,
            }) }) }));
}
